<template>
  <popup
    class="overflow-scroll mt-10 rounded-lg"
    :opened="dataToShow"
    @close="changeToShow(false)"
    :dynamic-height="true"
    :crossed-absolute-component="true"
  >
    <div class="my-5 lg:my-15 2xl:my-20">
      <h3 class="">
        Résultats de la recherche
      </h3>

      <div
        v-if="errorMsg !== ''"
        class="text-sm text-pink-600 flex justify-center"
      >
        {{ errorMsg }}
      </div>

      <div
        class="w-2/3 mb-3 mt-6 mx-auto"
      >
        <search-bar
          name="results-search"
          :value="search"
          placeholder="Rechercher parmis les résultats (Nom et/ou taux de correspondance)"
          :inherits="false"
          :big="false"
          :has-border="false"
          @input="(newValue) => {search = newValue;}"
        />
      </div>


      <div v-if="results.length > 0 && hasSearching">
        <list-grid
          :list-items="searchResult"
          grid="grid-cols-12"
        >
          <template #header>
            <div
              class="col-start-1 md:col-start-2 col-span-4 md:col-span-3 ml-2 md:ml-0 truncate"
            >
              Bénéficiaires
            </div>
            <div class="col-span-3 truncate">
              Taux de correspondance
            </div>
            <div class="col-span-3 truncate">
              Actions rapides
            </div>
          </template>
          <template #accordionDescription="{ num: index, item: result }">
            <div class="hidden md:inline col-span-1 justify-self-center">
              <profile-picture
                :id="'photo' + index"
                size="max-w-12 w-12 h-12"
                :is-circle-avatar="true"
                :other-object="typeof result === 'object' ? result : {}"
                specific-rounded="rounded-xl"
              />
            </div>
            <!-- Profile picture -->
            <div
              class="col-start-1 md:col-start-2 col-span-4 md:col-span-3 ml-2 md:ml-0 text-lg"
            >
              {{ result.firstname }} {{ result.lastname }}
            </div>
            <!-- Name -->
            <div class="col-span-3">
              <div class="relative">
                <div
                  class="w-max cursor-pointer"
                  @click.stop="displayResult(index)"
                >
                  <circular-gauge
                    :value="result.percentage"
                    :key="result.percentage"
                  />
                </div>
                <div
                  v-click-outside="forceHide"
                  v-if="numResultdisplayed === index"
                  class="overflow-visible absolute shadow-xl bg-white rounded-xl px-10 pt-8 top-10/12 left-15 transform -translate-x-1/2 text-base z-20 w-screen md:w-max md:max-w-xl xl:max-w-2xl 2xl:max-w-3xl"
                >
                  <div class="flex flex-col space-y-10 mb-20">
                    <div
                      class="space-y-2.5"
                      v-if="result.compperso"
                    >
                      <div class="text-base uppercase text-indigo-600 mb-5">
                        Compétences personnelles
                      </div>
                      <div class="flex flex-col space-y-2.5">
                        <div
                          v-for="(perso, kperso) in result.compperso.multi3"
                          :key="kperso"
                          class="flex flex-col space-y-2.5"
                        >
                          <div class="font-semibold">
                            {{ kperso }}
                          </div>

                          <div
                            v-for="(compPerso, kCompPerso) in perso"
                            :key="kCompPerso"
                          >
                            <div
                              class="flex flex-col md:flex-row md:space-x-20 justify-between"
                            >
                              <div>{{ compPerso.libelle }}</div>
                              <div
                                :class="{
                                  'text-gray-600': !compPerso.evaluated,
                                  'text-teal-600': compPerso.isMatched,
                                  'text-pink-600': !compPerso.isMatched,
                                }"
                              >
                                {{ compPerso.evaluated || 'Non évalué' }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          v-for="(persoClea, kpersoClea) in result.compperso
                            .clea"
                          :key="kpersoClea"
                          class="flex flex-col space-y-2.5"
                        >
                          <div class="font-semibold">
                            {{ kpersoClea }}
                          </div>
                          <div
                            v-for="(compPersoClea, kCompPersoClea) in persoClea"
                            :key="kCompPersoClea"
                          >
                            <div
                              class="flex flex-col md:flex-row md:space-x-20 justify-between"
                            >
                              <div>{{ compPersoClea.libelle }}</div>
                              <div
                                :class="{
                                  'text-teal-600': compPersoClea.isMatched,
                                  'text-pink-600': !compPersoClea.isMatched,
                                }"
                              >
                                {{
                                  compPersoClea.isMatched
                                    ? 'Oui'
                                    : 'Non' || 'Non évalué'
                                }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      class="space-y-2.5"
                      v-if="result.compsocio"
                    >
                      <div class="text-base uppercase text-indigo-600 mb-5">
                        Compétences socio-professionnelles
                      </div>
                      <div
                        v-for="(socio, ksocio) in result.compsocio"
                        :key="ksocio"
                        class="flex flex-col space-y-2.5"
                      >
                        <div class="font-semibold">
                          {{ ksocio }}
                        </div>
                        <div
                          v-for="(compSocio, kCompSocio) in socio"
                          :key="kCompSocio"
                          class="flex flex-col md:flex-row md:space-x-20 justify-between"
                        >
                          <div>{{ compSocio.libelle }}</div>
                          <div
                            :class="{
                              'text-gray-600': !compSocio.evaluated,
                              'text-teal-600':
                                compSocio.evaluated && compSocio.isMatched,
                              'text-pink-600':
                                compSocio.evaluated && !compSocio.isMatched,
                            }"
                          >
                            {{ compSocio.evaluated || 'Non évalué' }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      class="space-y-2.5"
                      v-if="result.comppro"
                    >
                      <div class="text-base uppercase text-indigo-600 mb-5">
                        Compétences professionnelles
                      </div>
                      <div
                        v-for="(pro, kpro) in result.comppro"
                        :key="kpro"
                        class="flex flex-col space-y-2.5"
                      >
                        <div class="font-semibold">
                          {{ kpro }}
                        </div>
                        <div
                          v-for="(compPro, kCompPro) in pro"
                          :key="kCompPro"
                          class="flex flex-col md:flex-row md:space-x-20 justify-between"
                        >
                          <div>{{ compPro.libelle }}</div>
                          <div
                            :class="{
                              'text-gray-600': !compPro.evaluated,
                              'text-teal-600':
                                compPro.evaluated && compPro.isMatched,
                              'text-pink-600':
                                compPro.evaluated && !compPro.isMatched,
                            }"
                          >
                            {{ compPro.evaluated || 'Non évalué' }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Percentage -->
            <div class="col-span-3 flex md:space-x-2">
              <circle-button
                icon="eye"
                label="Voir les résultats"
                @buttonClick="displayResult(index)"
              />
              <router-link
                target="_blank"
                :to="'/form/neopass/' + result.id"
              >
                <circle-button
                  icon="layers"
                  :label="
                    'Accéder au carnet de parcours de ' +
                      result.firstname +
                      ' ' +
                      result.lastname
                  "
                  :enable-click="false"
                />
              </router-link>

              <circle-button
                icon="download"
                :label="
                  'Télécharger le carnet de parcours de ' +
                    result.firstname +
                    ' ' +
                    result.lastname +
                    ' en PDF'
                "
                @buttonClick="downloadNeopass(result)"
              />
            </div>
            <!-- Actions -->
          </template>
        </list-grid>
      </div>
      <div
        v-if="results.length == 0 && hasSearching"
        class="flex flex-col justify-center items-center w-full"
      >
        <h3
          class="text-pink-600 w-full text-center font-semibold text-lg mt-12"
        >
          Aucun bénéficiaire
        </h3>
        <h4 class="text-indigo-600 w-4/6 text-center text-base mt-8 mb-16">
          Il n'y a aucun bénéficiaire qui correspond à votre recherche
        </h4>
        <div>
          <illustration name="no_result" />
        </div>
      </div>

      <div
        v-if="!hasSearching"
        class="flex flex-col justify-center items-center w-full"
      >
        <h3
          class="text-pink-600 w-full text-center font-semibold text-lg mt-12"
        >
          Aucun filtre de recherche
        </h3>
        <h4 class="text-indigo-600 w-4/6 text-center text-base mt-8 mb-16">
          Vous n'avez sélectionné aucun filtre de recherche
        </h4>
        <div>
          <illustration name="no_result" />
        </div>
      </div>
    </div>
    <!-- END Content modal add beneficiary to a referent -->
  </popup>
</template>

<script>
import Icon from './../../../components/Icon.vue';
import Popup from './../../../components/Popup.vue';
import CircleButton from './../../../components/CircleButton.vue';
import ProfilePicture from './../../../components/ProfilePicture.vue';
import Illustration from './../../../components/Illustration.vue';
import CircularGauge from './../../../components/CircularGauge.vue';
import JsFileDownload from 'js-file-download';
import ClickOutside from 'vue-click-outside';
import axios from './../../../api';
import { mapGetters } from 'vuex';
import ListGrid from '../../../components/AccordionTable/ListGrid.vue';
import SearchBar from '../../../components/Inputs/SearchBar.vue';

export default {
  name: 'SearchResultsPopup',

  components: {
    SearchBar,
    ListGrid,
    Icon,
    Popup,
    CircleButton,
    ProfilePicture,
    Illustration,
    CircularGauge,
    JsFileDownload,
  },

  props: {
    results: {
      type: Array,
      required: false,
      default: [],
    },

    dataToShow: Boolean,
  },

  data() {
    return {
      numResultdisplayed: -1,
      listModulesToExport: [1, 2, 3, 4, 6, 7],
      errorMsg: '',
      search: '',
    };
  },

  methods: {
    changeToShow(val) {
      this.$emit('showChange', val);
    },

    displayResult(index) {
      if (this.numResultdisplayed > -1) {
        this.numResultdisplayed = -1;
        return;
      }

      this.numResultdisplayed = index;
    },

    forceHide() {
      if (this.numResultdisplayed > -1) {
        this.numResultdisplayed = -1;
      }
    },

    goToNeopass(index) {
      console.log('go to his neopass', this.results[index]);
    },

    async downloadNeopass(beneficiary) {
      await axios({
        url: '/api/pdf/neopass/' + beneficiary.id,
        method: 'POST',
        responseType: 'blob', // Important
        data: {
          listModules: this.listModulesToExport,
        },
      })
        .then((response) => {
          let filename = `Neopass - ${beneficiary.firstname} ${beneficiary.lastname}.pdf`;
          JsFileDownload(response.data, filename);
        })
        .catch((error) => {
          this.errorMsg =
            'Une erreur est survenue lors de l\'export des données en PDF. Veuillez contacter le service technique pour régler ce problème.';
          console.log('ERRRR:: ', error);
        });
    },
  },

  computed: {
    ...mapGetters({
      searching: 'rechercheCompetences/searching',
    }),

    hasSearching() {
      return (
        this.searching.compperso.filter(
          (c) => Object.keys(c.values.niveaux).length > 0
        ).length > 0 ||
        this.searching.compsocio.filter(
          (c) => Object.keys(c.values.niveaux).length > 0
        ).length > 0 ||
        this.searching.comppro.filter((c) => c.values.niveaux.length > 0)
          .length > 0
      );
    },

    sortedResults() {
      let results = this.results.map((res) => res);
      return results.sort((a, b) => {
        if (a.percentage > b.percentage) {
          return -1;
        } else if (a.percentage < b.percentage) {
          return 1;
        } else {
          return 0;
        }
      });
    },

    searchResult() {
      if (this.search === '') {
        return this.sortedResults;
      }

      const numbersArray = this.search.match(/\d+/g);
      const numbers = numbersArray ? numbersArray.map(Number) : [];

      console.log(`numbersArray: ${numbersArray}`);
      console.log(`numbers: ${numbers}`);

      return this.sortedResults.filter((result) => {
        console.group('filtering...');
        const fullName = `${result.firstname} ${result.lastname}`.toLocaleLowerCase();
        const searchWithoutNumbers = this.search.replace(/\d+/g, '').trim().toLowerCase();
        const nameMatch = fullName.includes(searchWithoutNumbers);

        console.log(`fullName: ${fullName}`);
        console.log(`searchWithoutNumbers: ${searchWithoutNumbers}`);
        console.log(`nameMatch: ${nameMatch}`);

        if (numbers.length === 0 ) {
          console.groupEnd();
          return nameMatch;
        }

        const [floor, ceiling] = [result.percentage - 5, result.percentage + 5];

        const numberMatch = numbers.reduce((previousValue, currentValue) => {
          return (floor < currentValue) && ( currentValue < ceiling ) || previousValue;
        }, false);

        console.log(`floor: ${floor}`);
        console.log(`ceiling: ${ceiling}`);
        console.log(`numberMatch: ${numberMatch}`);

        console.groupEnd();
        return nameMatch && numberMatch;
      });
    }
  },

  directives: {
    ClickOutside,
  },
};
</script>